import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import apiMcu from "api/mcu";
import { TooltipCC } from "components/common";
import { IconDeleteUser, IconEditUser } from "components/common/IconCommon";
import { SearchCC } from "components/common/SearchCC";
import { DIALOG_ID } from "components/Dialog/constant";
import { BreadcrumbsCC, ContainerPage } from "components/Layout";
import LoadingBackdrop from "components/Layout/Loading/LoadingBackdrop";
import SearchPage from "components/Layout/SearchPage";
import NotFoundData from "components/NotFound";
import { PaginationButtons, TableHeaderCC } from "components/Table";
import { headCellsMCUSettings } from "components/Table/Functions";
import { FUNCTIONS } from "constants/roles";
import { useResponsiveCC, useTableCC } from "hooks";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SwitchIOS from 'shared/components/base/SwitchIOS';
import { checkFunctionHaveCode } from "store/user/functions";
import { selectCurrentUserFunctions } from "store/selectors";
import theme from "theme";
import { transHeadCells } from 'utils/functions';
import { setCloseDialogCC, setOpenDialogCC, toastError, toastSuccess } from "utils/helpers";

const MCUSettings = () => {
    const [userName, setUserName] = useState('');
    const { t } = useTranslation();
    const { setCurrentPage, handleChangePage, sizeRow, currentPage } = useTableCC();
    const { isLargePC } = useResponsiveCC();
    const [reload, setReload] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const functions = useSelector(selectCurrentUserFunctions);

    const apiGetListSipAccount = (currentPage, userName) => {
        return apiMcu.getListSipAccount(currentPage, userName);
    }

    const apiUpdateSipAccount = (body, id) => {
        return apiMcu.updateSipAccount(body, id);
    }

    const apiDeleteSipAccount = (id) => {
        return apiMcu.deleteSipAccount(id);
    }

    const handleSwitchOnOff = (value, item) => {
        const body = {
            username: item.username,
            password: item.password,
            domain: item.domain,
            callerIdName: item.callerIdName,
            callerIdNumber: item.callerIdNumber,
            enabled: value
        }


        apiUpdateSipAccount(body, item.id)
            .then((result) => {
                toastSuccess(t('mcu.toast.updateSuccess'))
                setReload(prev => !prev);
            })
            .catch((error) => {
                toastError(t('mcu.toast.error'))
            })
    }

    const handleOpenDialogDelete = (name, id) => {
        const content = <div>
            {t('mcu.dialog.content.deleteAccount')} <span style={{ fontWeight: 700 }}>{name}</span>?
        </div>
        setOpenDialogCC({
            id: DIALOG_ID.CONFIRM,
            props: {
                title: t("mcu.dialog.title.deleteAccount"),
                contentText: content,
                isDisableLoadingButton: true,
                cancel: t('mcu.dialog.action.cancel'),
                action: t('mcu.dialog.action.deleteAccount'),
                onClick: () => {
                    apiDeleteSipAccount(id)
                        .then(result => {
                            toastSuccess(t('mcu.toast.deleteAccountSuccessfully'))
                            setReload(prev => !prev);
                        })
                        .catch(error => {
                            toastError(t('mcu.toast.error'))
                        })
                        .finally(() => {
                            setCloseDialogCC();
                        })
                }
            }
        })
    }

    useEffect(() => {
        setLoading(true);
        apiGetListSipAccount(currentPage, userName)
            .then((result) => {
                setData(result)
            })
            .catch((error) => {
                toastError(t('mcu.toast.error'))
            })
            .finally(() => {
                setLoading(false);
            })
    // eslint-disable-next-line
    }, [currentPage, reload])

    return (
        <ContainerPage>
            <LoadingBackdrop open={loading} />
            <BreadcrumbsCC>
                {
                    checkFunctionHaveCode(functions, FUNCTIONS.MCU_CONTROL_SIP_ACCOUNT_EDIT)
                    &&
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={
                            <AddCircleOutlineIcon
                                sx={{ color: 'white', width: theme.spacing(2.5), height: theme.spacing(2.5) }}
                            />
                        }
                        sx={{ marginLeft: '16px' }}
                        onClick={() => {
                            setOpenDialogCC({
                                id: DIALOG_ID.CREATE_SIP_USER,
                                props: {
                                    title: t('mcu.dialog.title.addAccount'),
                                    titleButtonAction: t('mcu.dialog.action.addAccount'),
                                    titleButtonCancel: t('mcu.dialog.action.cancel'),
                                    agreeAction: () => {
                                        setCurrentPage(0)
                                        setReload(prev => !prev);
                                    },
                                },
                            });
                        }}
                    >
                        <div style={{ fontWeight: '700' }}>{t('mcu.button.addAccount')}</div>
                    </Button>
                }
            </BreadcrumbsCC>
            <SearchPage>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                    <SearchCC
                        placeholder={'mcu.placeholder.enterUser'}
                        backgroundColor={'#FFFF'}
                        value={userName}
                        setValue={setUserName}
                        handleValue={(value) => {
                            setCurrentPage(0)
                            setReload(prev => !prev);
                        }}
                    />
                </Box>
            </SearchPage>
            <Box sx={{ margin: '24px 20px 0 20px', height: 'calc(100vh - 210px)', display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                <TableContainer
                    sx={{
                        overflowX: 'initial',
                        overflowY: 'auto',
                        height: isLargePC || window.innerHeight > 800 ? 'auto' : 'auto',
                    }}
                >
                    <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={sizeRow}>
                        <TableHeaderCC headCellTable={transHeadCells(headCellsMCUSettings, t)} styleHeadCell={{ boxShadow: 'none !important', borderBottom: '1px solid rgb(209, 209, 209) !important' }} />
                        <TableBody>
                            {
                                data?.data?.map((item, index) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={item.id} sx={{ cursor: 'auto' }}>
                                            <TableCell align="center">{index + 1}</TableCell>
                                            <TableCell sx={{ width: '340.37px' }}>{item.username}</TableCell>
                                            <TableCell sx={{ width: '340.37px' }}>{item.password}</TableCell>
                                            <TableCell sx={{ width: '340.37px' }}>{item.domain}</TableCell>
                                            <TableCell sx={{ width: '340.37px' }}>{item.lastOnlineAt ? t('mcu.table.content.lastActive', { date: moment(item.lastOnlineAt).format("HH:mm DD/MM/YYYY") }) : '-'}</TableCell>
                                            <TableCell sx={{ width: '130px' }} align="center">
                                                {
                                                    checkFunctionHaveCode(functions, FUNCTIONS.MCU_CONTROL_SIP_ACCOUNT_EDIT)
                                                    &&
                                                    <SwitchIOS
                                                        checked={item.enabled}
                                                        onChange={(e) => {
                                                            handleSwitchOnOff(e.target.checked, item);
                                                        }}
                                                    />
                                                }
                                            </TableCell>
                                            <TableCell >
                                                {
                                                    checkFunctionHaveCode(functions, FUNCTIONS.MCU_CONTROL_SIP_ACCOUNT_EDIT)
                                                    &&
                                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                        <TooltipCC title={t('mcu.tooltip.edit')}>
                                                            <IconButton
                                                                sx={{ marginRight: '16px' }}
                                                                onClick={() => {
                                                                    setOpenDialogCC({
                                                                        id: DIALOG_ID.CREATE_SIP_USER,
                                                                        props: {
                                                                            title: t('mcu.dialog.title.editAccount'),
                                                                            titleButtonAction: t('mcu.dialog.action.editAccount'),
                                                                            titleButtonCancel: t('mcu.dialog.action.cancel'),
                                                                            data: {
                                                                                user: item.username,
                                                                                pass: item.password,
                                                                                server: item.domain,
                                                                                username: item.username,
                                                                                password: item.password,
                                                                                domain: item.domain,
                                                                                displayName: item.callerIdName,
                                                                                callerIdNumber: item.callerIdNumber,
                                                                                id: item.id
                                                                            },
                                                                            agreeAction: () => {
                                                                                setReload(prev => !prev)
                                                                            },
                                                                        },
                                                                    });
                                                                }}
                                                                size={sizeRow}
                                                            >
                                                                <IconEditUser />
                                                            </IconButton>
                                                        </TooltipCC>
                                                        <TooltipCC title={t('mcu.tooltip.delete')}>
                                                            <IconButton onClick={() => {
                                                                handleOpenDialogDelete(item.username, item.id)
                                                            }} size={sizeRow}>
                                                                <IconDeleteUser />
                                                            </IconButton>
                                                        </TooltipCC>
                                                    </Box>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                {data.totalElements ? <PaginationButtons page={currentPage} handleChangePage={handleChangePage} limit={10} total={data.totalElements} /> : <></>}
                {data.totalElements === 0 && <NotFoundData />}
            </Box>

        </ContainerPage>
    )
}

export default MCUSettings;
